import React, { useState, useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";

const images = [
    "/banner_1.webp",
    "/banner_2.webp",
    "/banner_3.webp",
    // Add more image URLs as needed
];

const Hero = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isLoaded, setIsLoaded] = useState(false);
    const [, setImageLoadedStates] = useState({});

    // Preload images and track their loaded states
    useEffect(() => {
        const preloadImages = () => {
            const imagePromises = images.map((image, index) => {
                return new Promise((resolve) => {
                    const img = new Image();
                    img.src = image;
                    img.onload = () => {
                        setImageLoadedStates((prev) => ({ ...prev, [index]: true }));
                        resolve();
                    };
                    img.onerror = resolve; // Resolve even on error to not block
                });
            });

            // Wait for all images to load before rendering
            Promise.all(imagePromises).then(() => setIsLoaded(true));
        };

        preloadImages();
    }, []);

    useEffect(() => {
        if (!isLoaded) return;

        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [isLoaded]);

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                height: "60vh",
                overflow: "hidden",
                backgroundColor: "#f0f0f0", // Fallback background color
            }}
        >
            {/* Background images with cross-fade */}
            {images.map((image, index) => (
                <Box
                    key={index}
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        opacity: currentImageIndex === index && isLoaded ? 1 : 0,
                        transition: "opacity 0.8s ease-in-out",
                        zIndex: 0,
                    }}
                />
            ))}
            {/* Overlay */}
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.3)",
                    zIndex: 1,
                }}
            />

            {/* Content */}
            <Container
                maxWidth={false}
                sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    zIndex: 2,
                    color: "white",
                    textAlign: "center",
                }}
            >
                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: "bold",
                        color: "white",
                        mt: 2,
                        mb: 2,
                    }}
                >
                    Your Path to Dream Homes Starts Here
                </Typography>

                <Typography
                    variant="h6"
                    component="p"
                    sx={{
                        color: "rgba(255,255,255,0.8)",
                        mb: 4,
                        maxWidth: "800px",
                    }}
                >
                    As a trusted real estate agency, we provide expert guidance
                    and personalized service to help you find and secure your
                    ideal property.
                </Typography>
            </Container>
        </Box>
    );
};

export default Hero;
